import getCookie from "./getCookie"

function getSubmissionUrl({ locale, variant }) {
  // Valid variants are:
  // - '5g' or 'fleet' for lead submissions
  // - 'form' for the in-page form
  // - 'ebook' for the gated content download
  // - 'partner' for the partner lead form
  return `https://jarvis.inseego.com/inseego-${variant}-${locale}`
}

// Make a submission to the appropriate endpoint, automatically including extra
// data such as campaign details and submission page.
export default function submitForm(options, submissionData) {
  // Create the current and first submission timestamps
  const recentSubmissionTimestamp = new Date().toISOString()
  let firstSubmissionTimestamp = localStorage.getItem('first_submission_timestamp')
  if (!firstSubmissionTimestamp) {
    firstSubmissionTimestamp = recentSubmissionTimestamp
    localStorage.setItem('first_submission_timestamp', recentSubmissionTimestamp)
  }

  // Extend the submission data with additional information
  const extendedSubmissionData = {
    ...submissionData,
    submissionPage: window.location.href,
    recentSubmissionTimestamp,
    firstSubmissionTimestamp,
  }

  // Add recent campaign details (if available)
  const recentCampaignDetailsJson = localStorage.getItem('campaign_details')
  if (recentCampaignDetailsJson) {
    extendedSubmissionData.recentCampaignDetails = JSON.parse(recentCampaignDetailsJson)
  }

  // Add first campaign details (if available)
  const firstCampaignDetailsJson = localStorage.getItem('first_campaign_details')
  if (firstCampaignDetailsJson) {
    extendedSubmissionData.firstCampaignDetails = JSON.parse(firstCampaignDetailsJson)
  }

  // Add campaign history (if available)
  const campaignHistoryJson = localStorage.getItem('campaign_history')
  if (campaignHistoryJson) {
    extendedSubmissionData.campaignHistory = JSON.parse(campaignHistoryJson)
  }

  // Add the HubSpot cookie to the submission data
  const hubspotUtk = getCookie('hubspotutk')
  if (hubspotUtk) {
    extendedSubmissionData.hubspotUtk = hubspotUtk
  }

  const submissionUrl = getSubmissionUrl(options)

  return fetch(submissionUrl, {
    method: 'POST',
    body: JSON.stringify(extendedSubmissionData),
  })
}
